import { http } from './config'

export default {

  getDailyOperations: (date, locality) => {
    return http.get(`daily_operations?date=${date}&locality_id=${locality}`)
  },

  getDailyOperationsById: (id) => {
    return http.get(`daily_operations/${id}`)
  },

  getDailyOperationsWorked: (id) => {
    return http.get(`daily_operations/${id}/worked`)
  },

  updateDailyOperation: (params) => {
    return http.put(`daily_operations/${params.id}`, { 
      daily_operation: {
        start_of_operation: params.start_of_operation,
        start_of_interval: params.start_of_interval,
        end_of_interval: params.end_of_interval,
        end_of_operation: params.end_of_operation,
        locality_id: params.locality_id,
      },
    })
  },

  createDailyOperation: (params) => {
    return http.post(`daily_operations`, { 
      daily_operation: {
        start_of_operation: params.start_of_operation,
        start_of_interval: params.start_of_interval,
        end_of_interval: params.end_of_interval,
        end_of_operation: params.end_of_operation,
        locality_id: params.locality_id,
      },
    })
  },

  removeDailyOperation: (daily_operation_id) => {
    return http.delete(`daily_operations/${daily_operation_id}`)
  },

  exportWorkedListsReport: (params) => {
    return http.get(`indicators/export_worked_lists_report`, { params })
  },

}
